<style scoped="scoped" lang="scss">
.container {
  padding-left: 24px;
  padding-right: 24px;
  overflow: auto;
  // width: calc(100% - 40px);
  min-width: 500px;

  .info {
    background-color: #F7F8FA;
    height: 28px;
    display: flex;
    margin-bottom: 12px;
    align-items: center;
    justify-content: flex-end;
    line-height: 28px;
    color: #419FFF;
    font-size: 12px;
    font-family: 'Microsoft YaHei UI';
  }

  .info-item {
    width: 100%;
    text-align: right;
    color: #419fff;
    display: flex;
  }

  // 表格
  .table {
    width: calc(100% - 0px);
    margin-top: 24px;

    .main {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;
      width: 100%;
      padding: 5px;
      color: #909399;

      .item {
        width: 50%;
        padding: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .label {
          width: 60%;
        }
      }
    }
  }
}
</style>
<template>
  <div class="container">
    <!--  信息-->
    <div class="info" v-loading="searchLoading">
      <div class="info-item">
        <div style="flex: 1; text-align: right;">{{$t('mei6xiaoshishuaxinyici')}}</div>
        <div style="margin-left: 20px;" v-if="utils.checkPower('web_report_equipment_alarm_refresh')">
          <el-button size="mini" @click="refresh" type="primary">{{ $t('jishishengchengshangyirishuju') }}</el-button>
        </div>
      </div>
    </div>
    <div class="form" style="margin-bottom: 20px;">
      <el-form style="height:28px;" :model="deviceAlarm.searchForm" :inline="true" size="mini">
        <el-form-item :label="$t('tongjishijian')">
          <yi_time_input :format="'yyyy-MM-dd'" :maxTime="31 * 24 * 3600 * 1000" type="daterange" :start.sync="deviceAlarm.searchForm.startTimeStart" :end.sync="deviceAlarm.searchForm.startTimeEnd"> </yi_time_input>
        </el-form-item>
        <el-form-item :label="$t('shebeimingcheng')">
          <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="deviceAlarm.searchForm.equipmentId"> </yi_data_select>
        </el-form-item>
        <el-form-item :label="$t('chixushijian (fenzhong) dayu')">
          <el-input v-model="deviceAlarm.searchForm.duration"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDeviceAlarm" plain>{{ $t('sousuo') }} </el-button>
          <el-button type="default" @click="resetDeviceAlarm" plain style="margin-left: 10px;">
            {{ $t('chongzhi') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="float: right; margin-top: 8px; margin-bottom: 8px;">
      <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()"> </el-button>
    </div>
    <!-- 表单 -->
    <div class="table">
      <el-table :data="deviceAlarm.tableData" size="mini" border style="width: 100%" v-loading="searchLoading" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
        <el-table-column v-for="(item, index) in deviceAlarm.tableColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ item.isTranslated ? $t(scope.row[item.prop]) : scope.row[item.prop] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('guzhangleixing')" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.alarmType === 1 ? 'warning' : 'danger'">
              {{ $t(store.state.dictJsonAll['EQUIPMENT_ALARM_TYPE'][scope.row.alarmType]) }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div style="float: right; margin-top:8px">
        <el-pagination class="fy" layout="total, prev, pager, next,sizes" :current-page="deviceAlarm.currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handleCurrentChange" @next-click="handleCurrentChange" :total="parseInt(deviceAlarm.total)" :pagerCount="5" background> </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import XLSX from 'xlsx';
const date = new Date();
const startTime = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0).getTime();
const endTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59).getTime();
export default {
  name: 'web_report_equipment_alarm_list',
  data() {
    return {
      searchLoading: false,
      exportLoading: false,
      fildIds: '',
      timer: null,
      // refreshOneKey: 0,
      deviceAlarm: {
        searchForm: {
          equipmentId: [],
          startTimeStart: startTime,
          startTimeEnd: endTime,
          summaryDate: [],
          duration: 0
        },
        tableData: [],
        tableColumn: [
          {
            prop: 'equipmentName',
            sortable: false,
            label: 'shebeimingcheng'
          },
          {
            prop: 'alarmMsg',
            label: 'baojingxinxi',
            isTranslated: true
          },
          {
            prop: 'startTime',
            sortable: false,
            label: 'kaishishijian'
          },
          {
            prop: 'endTime',
            sortable: false,
            label: 'jieshushijian'
          },
          {
            prop: 'duration',
            sortable: false,
            label: 'chixushijian (fenzhong)'
          }
        ],
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    };
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    // JS前端导出全部数据为Excel
    exportExcel() {
      this.exportLoading = true;
      const equipmentId = Array.isArray(this.deviceAlarm.searchForm.equipmentId)
        ? this.deviceAlarm.searchForm.equipmentId.join(',')
        : this.deviceAlarm.searchForm.equipmentId || '';
      const pageParam = {
        ...this.deviceAlarm.searchForm,
        equipmentId,
        endTimeStart: this.deviceAlarm.searchForm.startTimeStart,
        endTimeEnd: this.deviceAlarm.searchForm.startTimeEnd,
        duration: this.deviceAlarm.searchForm.duration * 60,
        pageSize: 999999,
        pageNum: 1,
        orderBy: 'startTime asc'
      };
      this.http
        .get('/web/report/page/equipment_alarm?' + this.qs.stringify(pageParam))
        .then(response => {
          const rows = (response.data && response.data.rows) || [];
          const headers = [
            this.$t('shebeimingcheng'),
            this.$t('baojingxinxi'),
            this.$t('kaishishijian'),
            this.$t('jieshushijian'),
            this.$t('chixushijian (fenzhong)'),
            this.$t('guzhangleixing')
          ];
          const tableData = [headers];
          const alarmTypeDict =
            this.store && this.store.state && this.store.state.dictJsonAll
              ? this.store.state.dictJsonAll['EQUIPMENT_ALARM_TYPE']
              : null;
          for (let i = 0; i < rows.length; i++) {
            const row = rows[i] || {};
            const alarmTypeLabel =
              alarmTypeDict && row.alarmType != null && alarmTypeDict[row.alarmType]
                ? this.$t(alarmTypeDict[row.alarmType])
                : row.alarmType != null
                ? row.alarmType
                : '';
            tableData.push([
              row.equipmentName || '',
              row.alarmMsg ? this.$t(row.alarmMsg) : '',
              row.startTime ? this.dateFormat(row.startTime) : '',
              row.endTime ? this.dateFormat(row.endTime) : '',
              row.duration != null ? (row.duration / 60).toFixed(1) : '',
              alarmTypeLabel
            ]);
          }
          const worksheet = XLSX.utils.aoa_to_sheet(tableData);
          worksheet['!cols'] = this.calcExcelColWidths(tableData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
          XLSX.writeFile(
            workbook,
            `设备报警_导出_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`
          );
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    // 按内容计算Excel列宽（中文按2个字符宽度）
    calcExcelColWidths(data) {
      if (!data || !data.length) return [];
      const colCount = data[0].length;
      const widths = [];
      for (let c = 0; c < colCount; c++) {
        let max = 10;
        for (let r = 0; r < data.length; r++) {
          const cell = data[r][c];
          if (cell == null || cell === '') continue;
          const str = String(cell);
          let len = 0;
          for (let i = 0; i < str.length; i++) {
            len += str.charCodeAt(i) > 255 ? 2 : 1;
          }
          if (len > max) max = len;
        }
        widths.push({ wch: Math.min(max + 2, 60) });
      }
      return widths;
    },
    //导出（原服务端导出，保留）
    exportAlarm() {
      this.exportLoading = true;
      let requestParam = {
        ...this.deviceAlarm.searchForm,
        equipmentId:this.deviceAlarm.searchForm.equipmentId.join(','),
        endTimeStart:this.deviceAlarm.searchForm.startTimeStart,
        endTimeEnd:this.deviceAlarm.searchForm.startTimeEnd,
        duration:this.deviceAlarm.searchForm.duration*60,
        orderBy: 'startTime'
      };
      return this.http
        .get('/web/report/export/equipment_alarm_export?' + this.qs.stringify(requestParam))
        .then(response => {
          let fildId = response.data;
          return this.http
            .get('/web/report/work/get', {
              params: {
                id: fildId
              }
            })
            .then(response => {
              this.fildIds = response.data.fileId;
              console.log('response.msg1', response.data.status);
              let status = response.data.status;
              if (status == 1) {
                this.getDownload();
                this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                this.$message.success(this.$t(response.msg));
              } else if (status == -1) {
                this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                this.$message.success(this.$t(response.msg));
              } else if (status == 0 || null) {
                this.timer = setInterval(() => {
                  this.getDownload();
                }, 1000);
              }
            })
            .finally(() => {
              this.exportLoading = false;
            });
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    getDownload() {
      console.log('this.fildIdthis.fildId', this.fildIds);
      return this.http.get('/web/customer/files/download?id=' + this.fildIds).then(res => {
        let baseUrl = res.data;
        if (res.data) {
          window.open(baseUrl);
        }
      });
    },
    resetDeviceAlarm() {
      orderBy: 'startTime asc';
      this.deviceAlarm.searchForm = {
        equipmentId: null,
        summaryDate: '',
        duration: 0
      };
      this.deviceAlarm.tableData = undefined;
    },
    handleSizeChange(value) {
      this.deviceAlarm.pageSize = value;
      this.getDeviceAlarm();
    },
    handleCurrentChange(value) {
      this.deviceAlarm.currentPage = value;
      this.getDeviceAlarm();
    },
    refresh(){
      this.$confirm(this.$t('本操作将生成上一天设备报警数据，是否确认刷新?'), this.$t('tishi'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      }).then(() => {
        this.searchLoading = true;
        this.http.post('/web/report/equipment/alarm/syncByCustomer').then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.getDeviceAlarm();
          this.isShowActionDialog = false;
        })
            .catch(err => {
              this.utils.errorMessage(err);
            })
            .finally(() => {
              this.searchLoading = false;
            });
      }).catch(() => {});
    },
    changeDeviceAlarm(value) {
      if (value === null) {
        return false;
      }
      const start = new Date(value[0]).getTime();
      const end = new Date(value[1]).getTime();
      const diff = end - start;
      const max = 3600 * 24 * 1000 * 30;
      console.log('fffff', max);
      if (diff > max) {
        this.$message.error(this.$t('shijiankuadubunengchaoguo31tian'));
        this.deviceAlarm.searchForm.summaryDate = [];
      }
    },
    async getDeviceAlarm() {
      this.searchLoading = true;
      let pageParam = {
        ...this.deviceAlarm.searchForm,
        equipmentId:this.deviceAlarm.searchForm.equipmentId.join(','),
        endTimeStart:this.deviceAlarm.searchForm.startTimeStart,
        endTimeEnd:this.deviceAlarm.searchForm.startTimeEnd,
        duration:this.deviceAlarm.searchForm.duration*60,
        pageSize: this.deviceAlarm.pageSize,
        pageNum: this.deviceAlarm.currentPage,
        orderBy: 'startTime asc'
      };
      let response = await this.http
        .get('/web/report/page/equipment_alarm?' + this.qs.stringify(pageParam))
        .then(response => {
          this.deviceAlarm.tableData = response.data.rows;
          this.deviceAlarm.total = response.data.total;
        })
        .catch(error => {
          this.$message.error(error);
        })
        .finally(() => {
          this.searchLoading = false;
        });

      if (this.deviceAlarm.tableData.length > 0) {
        for (let i = 0; i < this.deviceAlarm.tableData.length; i++) {
          this.deviceAlarm.tableData[i]['duration'] = (this.deviceAlarm.tableData[i]['duration'] / 60).toFixed(1);
          this.deviceAlarm.tableData[i]['startTime'] = this.dateFormat(this.deviceAlarm.tableData[i]['startTime']);
          this.deviceAlarm.tableData[i]['endTime'] = this.dateFormat(this.deviceAlarm.tableData[i]['endTime']);
        }
      }
    },
    // 日期转换
    dateFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = 'Y-m-d h:i:s';
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds
      };
      return format.replace(/\w/g, o => {
        return hash[o];
      });
    }
  }
};
</script>
